import { TypeContainer, Types } from '../actions/typeContainer';

export const getPathname =
  ({ isJourney1, isJourney2 }: TypeContainer) =>
  (nextPage: number | string) => {
    if (isJourney1) {
      return `/${Types.journey1}/${nextPage}`;
    }

    if (isJourney2) {
      return `/${Types.journey2}/${nextPage}`;
    }

    return `/${Types.journey3}/${nextPage}`;
  };
